export default __webpack_public_path__ + "static/media/sub-app-timecard-reminder-pic.dac51b45e58fbd18b6c813fc67710279.jpg";